import { FunctionComponent } from 'react';
import { CoUsersWidget } from 'widgets/CoUsers';
import { PageWrapper } from 'pages/_layouts/PageWrapper';

export const CoUsers: FunctionComponent = () => {
	return (
		<PageWrapper>
			<CoUsersWidget />
		</PageWrapper>
	);
};
